var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:'wrapper-' + _vm.$store.getters.platform},[(!_vm.category && !_vm.noData)?_c('app-loader'):_c('div',[_c('Grid',{attrs:{"options":{
        type: !_vm.category.is_final ? 'card-categories' : 'card-contents',
        title: _vm.category.name,
        items: !_vm.category.is_final ? _vm.category.child_categories : _vm.category.category_content,
        route: !_vm.category.is_final ? 'content-category' : 'content-detail',
        card: _vm.category.card,
      }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23002490","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contents/LiveCategories.vue
// module id = null
// module chunks = 